<template lang="pug">
footer(class="or-footer bg-white lg:bg-black")
    SplashBar

    Navigation(v-if="!isSimpleMode")

    LegalBar
</template>

<script>
import SplashBar from './_components/splashBar'
import Navigation from './_components/navigation'
import LegalBar from './_components/legalBar'

export default {
    components: {
        SplashBar,
        Navigation,
        LegalBar,
    },
    computed: {
        isSimpleMode() {
            return this.$store.state.isSimpleMode
        },
    },
}
</script>
